import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { DatasheetFacade } from '@mitsubishi/project/data-access';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-working-condition-wrapper',
  templateUrl: './working-condition-wrapper.component.html',
  styleUrls: ['./working-condition-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckbox, FormsModule, ApmTranslatePipe, NgClass, AsyncPipe],
})
export class WorkingConditionWrapperComponent extends FieldWrapper implements OnInit {
  isEditing$ = inject(DatasheetFacade).isEditing$;
  areAllFieldsHidden = false;

  onToggle(event: MatCheckboxChange) {
    if (event.checked) {
      this.form.enable();
    } else {
      this.form.disable();
    }
  }

  ngOnInit(): void {
    if (this.props.isActive === false || this.props.disabled === true) {
      setTimeout(() => {
        this.form.disable();
      }, 0);
    }

    this.areAllFieldsHidden = this.field.fieldGroup
      ? this.field.fieldGroup.every(field => field.props?.hidden === true)
      : true;
  }
}
